import { observable, action, ObservableMap, toJS } from 'mobx';
import {
    generateCreate,
    generateList,
} from './actionCreator';
import _ from '../translations';
import get from 'lodash/get';

class ProductAddonStore {
    @observable
    collection = new ObservableMap();
    @observable
    details = new ObservableMap();

    constructor() {
        this.baseUrl = '/api/commerce/productAddons';
    }

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    async create({ item = {} } = {}) {
        return await generateCreate({
            item,
            url: `${this.baseUrl}/createProductAddons/`,
            store: this,
            customError: _('There was a problem creating the product'),
        })();
    }

    @action.bound
    async listGenericAddons({ hash, params = {} } = {}) {
        return await generateList({
            hash,
            params,
            url: `${this.baseUrl}/listProductAddons/`,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem to obtaining products addons'),
        })();
    }

    @action.bound
    async listContainers({ hash, params = {} } = {}) {
        params = { 
            ...params,
            isServerless: true,
            fields: ['_id', 'name'],
            'filterBy-gateways.price.currency': 'usd',
            'filterBy-gateways.interval.period': 'year,month',
        }

        return await generateList({
            hash,
            params,
            url: `/api/commerce/admin/listContainers`,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem to obtaining containers'),
        })();
    }

    listContainersForSelect() {
        const containers = toJS(this
            .collection.get('containerList'))
        
        return containers.map(item => ({
            text: get(item ,'name.original', 'Empty name'),
            value: item._id,
        }));
    }
}

export default new ProductAddonStore();
